import { authFetch } from './authFetch';
import { useOrg } from './useOrg';

export const orgFetch = async (url, options = {}) => {
    // Get the current org ID
    const { orgId } = useOrg();

    // Merge organization header with any existing headers
    const requestOptions = {
        ...options,
        credentials: 'include', // Always include credentials
        headers: {
            ...options.headers,
            Organization: orgId.value
        }
    };

    // Call authFetch with the updated options
    return authFetch(url, requestOptions);
};